import { axiosInstance } from "@/config/axios";
import { Process } from "@/types/contract";
import { IdentificationQueryParams } from "@/types/queryParams";
import { contractSchema } from "@/types/schemas/contract";
import { objectToCamel, objectToSnake } from "ts-case-convert";
import { z } from "zod";

const responseSchema = z.object({
  contractRequest: contractSchema,
  contractRequestUuid: z.string(),
  sessionKey: z.string(),
});

const removeNullValues = (obj: Partial<IdentificationQueryParams>) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value != null)) as Partial<IdentificationQueryParams>;
};

export const createRequest = async (params: Partial<IdentificationQueryParams>) => {
  const body = removeNullValues(params);
  if (body.process === Process.PS) {
    body.processReason ??= "01";
    body.segment ??= "B2C";
    body.requestMethod ??= "D";
  }

  const response = await axiosInstance.post("/request", objectToSnake(body));

  const parsedResponse = responseSchema.safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }

  return {
    uuid: parsedResponse.data.contractRequestUuid,
    sessionKey: parsedResponse.data.sessionKey,
    contract: {
      ...parsedResponse.data.contractRequest,
      uuid: parsedResponse.data.contractRequestUuid || parsedResponse.data.contractRequest.uuid,
    },
  };
};
